import { Component, OnInit, Injector } from '@angular/core';
import { BaseView } from 'src/app/submodules/angular-ui-common/base-view';

/**
 * https://github.com/gabrielbusarello/material2-carousel
 */
@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent extends BaseView {

  // slides = [
  //   {
  //     image: './assets/images/carousel.jpeg',
  //     //text: 'Next opening 15/7/2021'
  //   }]

  slides = [
    /**
     * VERSIONE FINO a GENNAIO 2025
     */
    // {
    //   image: './assets/images/carousel.jpeg',
    //   text: 'In life,',
    //   text2: 'winning and losing',
    //   text3: 'will both happen.',
    //   text4: 'What is',
    //   text5: 'never acceptable',
    //   text6: 'is quitting.'
    // },
     /**
     * END VERSIONE FINO a GENNAIO 2025
     */
    // {
    //   image: './assets/images/carousel-2.jpeg',
    //   //text: 'EXCLUSIVE TRAINING LOCATION'
    //   text: 'EXCLUSIVE',
    //   text2: 'TRAINING',
    //   text3: 'LOCATION'
    //  //text: 'Personal trainer e pilates nel cuore di Torino'
    // }//,
    {
      image: './assets/images/carousel.jpg',
      text: 'Training with a smile and with love'
     // text2: ' and with love'
      // text3: 'will both happen.',
      // text4: 'What is',
      // text5: 'never acceptable',
      // text6: 'is quitting.'
    },
    {
      image: './assets/images/carousel2.jpg',
      text: 'Training with a smile and with love'
      //text2: ' and with love'
    },
    {
      image: './assets/images/carousel3.jpg',
      text: 'Training with a smile and with love'
      //text2: ' and with love'
    }
  ]
  
 
  constructor(protected _injector: Injector) {super(_injector) }

  ngOnInit(): void {
  }

}
